import * as React from "react";
import {useState} from "react";
import {UitkCalloutCard, UitkCalloutCardActionTypes, UitkCalloutCardTheme} from "@egencia/uitk-react";

export const ArticleError = (props) => {
    const [showBanner, setShowBanner] = useState(true);
    const articleNotAvailableText = uitk.i18n.msg('article_not_available');

    return (
        <div style={props.style} className={props.className}>
            {showBanner &&
            <UitkCalloutCard
                theme={UitkCalloutCardTheme.error}
                headingText={articleNotAvailableText}
                action={UitkCalloutCardActionTypes.close}
                onClickAction={() => setShowBanner(false)}
            /> }
        </div>
    );
}